// src/app/callback/callback.component.ts
import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProxyDataService } from '@app/core/http';
import { appConstants } from '@app/common/app-constants';
import { LoginService } from '@app/authentication/login/login.service';
import { HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { DOCUMENT } from '@angular/common';
import { Logger } from '@core/lib/services';
import { ModalRef } from '@core/lib/components/modal/modal-ref';
import { TranslateService } from '@ngx-translate/core';
import { ExamSharingPageService } from '@app/di/exam-sharing/exam-sharing-page.service';
import { WindowRef } from '@app/common/window-ref.service';
import { LogLevel } from '@core/lib/services/log-entry';

const log = new Logger('WfmhomecallbackComponent');

@Component({
  selector: 'app-callback',
  templateUrl: './wfmhomecallback.component.html',
  styleUrls: ['./wfmhomecallback.scss']
})
export class WfmhomecallbackComponent implements OnInit {
  clicked = false;
  userName;
  authCode;
  codeVerifierPKCE: string | null = null;
  redirectURI: string | null = null;
  @ViewChild('wfmhome') wfmhomeloadingTemplate: TemplateRef<any>;

  wfmhomeModalInstance: ModalRef;

  constructor(
    private route: ActivatedRoute,
    private dataService: ProxyDataService,
    private loginService: LoginService,
    private cookieService: CookieService,
    @Inject(DOCUMENT) private document: any,
    private router: Router,
    private translate: TranslateService,
    private examSharingPageService: ExamSharingPageService,
    private windowRef: WindowRef
  ) {}

  ngOnInit(): void {
    const codeVerifier = this.cookieService.get('code_verifier');
    log.debug('Retrieved Code Verifier from Cookie:', codeVerifier);
    const callbackurl = window.location.origin + appConstants.appURLs.wfmCallBackURL;
    log.debug('callback url:', callbackurl);
    this.route.queryParams.subscribe(params => {
      const code = params['code'];
      const state = params['state'];
      this.getToken(code, codeVerifier, callbackurl, state);
    });
  }

  private getToken(code: any, codeVerifier: string, callbackurl: string, state: string) {
    log.debug('ater redirect codeVerifier ', codeVerifier, 'callbackurl ', callbackurl);
    this.queryParamParse(state);
    const login$ = this.dataService.httpPost(
      appConstants.appURLs.loginSSO,
      {
        authCode: code,
        codeVerifierPKCE: codeVerifier,
        redirectURI: callbackurl
      },
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        })
      }
    );
    login$.then(
      successResponse => {
        const username = this.extractUsername(successResponse.data?.newData);
        log.debug('Extracted Username:', username);
        this.userName = username;
        if (successResponse.userName) {
          this.userName = successResponse.userName;
        }
        this.loginService.username = this.userName;
        if (this.cookieService.get('sessionDisconect') === 'true') {
          this.cookieService.set('sessionDisconect', 'false');
          window.self.close();
        } else {
          this.loginService.navigateToLoginSuccessPage();
        }
      },
      (errorResponse: any) => {
        if (this.cookieService.get('sessionDisconect') === 'true') {
          this.cookieService.set('sessionDisconect', 'false');
          this.cookieService.set('sessionDisconectfail', 'true');
          window.self.close();
        }
        if (errorResponse?.status === 500 && errorResponse.error?.data?.message === 'service_unavailable') {
          this.loginService.ssoLoginError = this.translate.instant('login.page.serverUnavailable');
          this.router.navigate(['/login']);
        } else {
          this.loginService.ssoLoginError = this.translate.instant('login.page.internalServerError');
          this.router.navigate(['/login']);
        }
      }
    );
  }

  extractUsername(newData: string): string | null {
    try {
      // Check if `newData` contains the username
      if (newData && newData.includes('userName:')) {
        // Extract the username using string manipulation
        return newData.split('userName:')[1].trim();
      }

      return null; // Return null if username is not found
    } catch (error) {
      console.error('Error extracting username:', error);
      return null;
    }
  }

  private queryParamParse(state: string) {
    const stateParts = state ? state.split('|') : [];
    let sharedParams = null;

    if (stateParts[1]) {
      try {
        const params = JSON.parse(stateParts[1]);
        sharedParams = params['sharedParams'] || null;
        log.debug('Parsed Query Params:', params);
        this.updateConfigFromQueryParams(params);
      } catch (e) {
        sharedParams = null;
      }
    }

    this.examSharingPageService.initialLaunchParameters = sharedParams
      ? { event: 'OPEN_EXAM', encryptedExamIdentifier: sharedParams }
      : null;
  }

  private updateConfigFromQueryParams(params: any) {
    const appConfig = this.windowRef.nativeWindow[`appConfig`];
    appConstants.queryParams.forEach(param => {
      if (param === 'logLevel') {
        appConfig[param] = this.parseLogLevel(params[param]);
      } else if (param === 'reportType') {
        appConfig[param] = params[param] ? String(params[param]).toLowerCase() : undefined;
      } else {
        appConfig[param] = String(params[param]).toLowerCase() === 'true';
      }
    });
  }

  private parseLogLevel(logLevel) {
    logLevel = parseInt(logLevel);
    if (logLevel && logLevel in LogLevel) {
      return logLevel;
    }
    return LogLevel.ERROR;
  }
}
